import { render, staticRenderFns } from "./AuthForgotPassword.vue?vue&type=template&id=02896bd4"
import script from "./AuthForgotPassword.vue?vue&type=script&lang=js"
export * from "./AuthForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports